import { L as LinescaleComponent, d as defineCustomElement$1 } from './linescale-component.js';
const LsLinescale = LinescaleComponent;
const defineCustomElement = defineCustomElement$1;
export { LsLinescale, defineCustomElement };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm1hcHBpbmdzIjoiIiwiaWdub3JlTGlzdCI6W119